import fetch, { fetchJson } from 'utils/fetch';
import { serializeDiagnosticValues } from '../form/reducers/serialize';

export const getSitesByCase = siteCase =>
  fetchJson(`/pco-manager/cases/${siteCase}/sites.json`);

export const renderDiagnostic = (siteCase, type, site) => {
  const siteParams = `?site_id=${site}`;
  const suffix = type.toLowerCase();

  const url = siteCase
    ? `/pco-manager/cases/${siteCase}/diagnostics/${suffix}${siteParams}`
    : `/pco-manager/cases/diagnostics/${suffix}/new${siteParams}`;

  return fetch(url).then(res => res.text());
};

export const renderDiagnosticForNew = (type, site) => {
  const siteParams = `?site_id=${site}`;
  const suffix = type.toLowerCase();
  const url = `/pco-manager/cases/new/diagnostics/${suffix}/new${siteParams}`;
  return fetch(url).then(res => res.text());
};

export const validateDiagnosticForNew = (type, values = {}) => {
  const bodyJson = serializeDiagnosticValues(type, values) || values;

  const suffix = type.toLowerCase();
  return fetch(`/pco-manager/cases/new/diagnostics/${suffix}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyJson),
  }).then(res => res.text());
};

export const validateDiagnostic = (type, values = {}) => {
  const bodyJson = serializeDiagnosticValues(type, values) || values;

  const suffix = type.toLowerCase();
  return fetch(`/pco-manager/cases/diagnostics/${suffix}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyJson),
  }).then(res => res.text());
};

export const getTools = (siteCase, type, site) => {
  if (siteCase) {
    const toolsType = type.toLowerCase();
    const url = `/pco-manager/cases/${siteCase}/diagnostics/${toolsType}/tools.json?site_id=${site}`;

    return fetchJson(url);
  }

  return Promise.resolve([]);
};

export const scheduleStudy = (siteCase, data) =>
  fetch(`/pco-manager/cases/${siteCase}/study`, {
    method: 'POST',
    body: data,
  });



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/api/index.js